import { CircularProgress } from "@mui/material"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"

export function Loading() {
  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 30,
        }}
      >
        <CircularProgress size={80} />
      </Box>
    </Container>
  )
}
